import STATUS from '@integrations/pint-appstore-commons/src/enums/APP_STATUS.json';
import TRANSITION from '@integrations/pint-appstore-commons/src/enums/APP_STATUS_TRANSITION.json';

const statusToTransitionMap = {
    [STATUS.ADDED_FOR_DOMAIN_GROUPS]: TRANSITION.GROUP,
    [STATUS.DISABLED]: TRANSITION.DISABLE,
    [STATUS.ALLOWED]: TRANSITION.ALLOW,
    [STATUS.ALLOWED_ADDED_USER]: TRANSITION.ALLOW,
    [STATUS.ADDED_DOMAIN]: TRANSITION.ADD,
};

function getAppSettingsQuery({
    chosenTransition,
    selectedGroups,
    status,
    collaborationAppsHierarchy,
    collaborationAppsHierarchyAfterUpdate,
    appId,
}) {
    const appSettingsQuery = {
        appId,
    };

    if (chosenTransition === TRANSITION.GROUP) {
        appSettingsQuery.status = {
            transition: chosenTransition,
            groups: selectedGroups.map((group) => group.id),
        };
    } else if (statusToTransitionMap[status] !== chosenTransition) {
        appSettingsQuery.status = {
            transition: chosenTransition,
        };
    }

    if (
        collaborationAppsHierarchy.length !== collaborationAppsHierarchyAfterUpdate.length ||
        collaborationAppsHierarchyAfterUpdate.some((appId, index) => appId !== collaborationAppsHierarchy[index])
    ) {
        appSettingsQuery.editors = {
            collaborationAppsHierarchy: collaborationAppsHierarchyAfterUpdate,
            collaborationAppsPrioritizationEnabled: collaborationAppsHierarchyAfterUpdate.length > 0,
        };
    }

    return appSettingsQuery;
}

const checkFormHasChanges = (appSettingsQuery, hasSelectedGroupsChanged) => {
    const hasSelectedAdditionalSettings = Object.keys(appSettingsQuery).length !== 1;
    const hasChosenGroupTransition = appSettingsQuery.status && appSettingsQuery.status.transition === TRANSITION.GROUP;
    const hasDefaultAppSettingEditorsChanged = !!appSettingsQuery.editors;

    return hasChosenGroupTransition
        ? hasSelectedAdditionalSettings && (hasSelectedGroupsChanged || hasDefaultAppSettingEditorsChanged)
        : hasSelectedAdditionalSettings;
};

export { checkFormHasChanges, getAppSettingsQuery, statusToTransitionMap };
